import axios from 'axios'
import { applyInterceptors } from '../interceptors'

const apiVersion = 'v1'

const service = (baseURL: string) => {
  const executor = axios.create({ baseURL })
  applyInterceptors(executor)

  return executor
}

export { apiVersion, service }
